import { render, staticRenderFns } from "./receptionPage.vue?vue&type=template&id=0871de71&scoped=true&"
import script from "./receptionPage.vue?vue&type=script&lang=js&"
export * from "./receptionPage.vue?vue&type=script&lang=js&"
import style0 from "./receptionPage.vue?vue&type=style&index=0&id=0871de71&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871de71",
  null
  
)

export default component.exports